import React, {Component} from 'react';
import classNames from 'classnames';
import './DashboardTasks.scss';
import './DashboardTableBox.scss';
import moment from 'moment';

const getPendingTests = (tests) => {
    if (tests) {
        return tests
            .filter(t => t.status == 'pending')
          .sort((a, b) => (new Date(a.schedule)).getTime() - (new Date(a.schedule)));
    }

    return null;
};

const formatDate = (date) => {
  return moment(date).format('MM/DD/YYYY')
};

class DashboardPendingTests extends Component {
  constructor(props) {
    super(props);
    this.state = {expanded: false};
  }

  render() {
    const {icon, tests, title, onOpenTest} = this.props;
    const pendingTests = getPendingTests(tests);

    return (
      <div className={classNames("dashboard-tasks card dashboard-table-box", {
        'pending-tests': pendingTests.length > 0,
        expanded: this.state.expanded
      })}>
        <div className="header">
          <i className={`fa fa-${icon}`} />
          <span>
              {title} ({pendingTests
            ? pendingTests.length
            : 0})
            </span>
          <button
            type="button"
            className="button primary small toggle-expanded"
            aria-label={this.state.expanded ? `Close ${title}` : `Expand ${title}`}
            aria-expanded={this.state.expanded}
            onClick={() => this.setState(({expanded}) => ({expanded: !expanded}))}
          >
            <i className={`fa fa-${this.state.expanded ? 'times' : 'expand'}`} aria-hidden="true" />
            {this.state.expanded && ' Close'}
          </button>
        </div>
        {pendingTests &&
          <table className="table table-stripped layout-auto">
              <tbody>
                  {pendingTests.map((test) => {
                      return (
                          <tr key={test.id}>
                            <td className="red">
                              {formatDate(test.schedule)}
                              </td>
                            <td>
                             {test.test_template.title}
                            </td>
                              <td className="text-right">
                                  <button className="button small primary" onClick={() => onOpenTest(test)}>
                                      <i className="fa fa-edit"/>
                                      Take test
                                  </button>
                              </td>
                          </tr>
                      );
                  })}
              </tbody>
          </table>
        }
      </div>
    )
  }
};


export default DashboardPendingTests;
